import { Loadable, LoadableStatus } from '@anduin/shared';

export interface AppStateModel {
  // Number of draft bills that are assigned to the user. Can be set either via API or override (but only after billing module loads)
  assignedDraftBillCount: number;
  firmHasJobTemplates: Loadable<boolean>;
}

export const DEFAULT_APP_STATE_MODEL: AppStateModel = {
  assignedDraftBillCount: 0,
  firmHasJobTemplates: { status: LoadableStatus.DEFAULT },
};
